import React, { useState, useContext, useEffect } from "react";
import { Card, CardBody, } from "reactstrap";
import UseMoondanceApi from "../lib/api";
import { buildAccountParameter, formatCurrency } from "../lib/formatData";
import { MoondanceContext } from '../../App';

import Loading from "../lib/components/Loading.js";
import MoondanceTable from "../lib/components/MoondanceTable.js";
import { set } from "lodash";

function DashboardYearly() {

  const moondanceApi = UseMoondanceApi();
  const { selectedAccountList } = useContext(MoondanceContext);
  const { selectedStatus } = useContext(MoondanceContext);
  const { userCurrency } = useContext(MoondanceContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  //console.log(selectedOwner);


  useEffect(() => {
    async function fetchData() {
      try {
        var api_parameters = {
          account: buildAccountParameter(selectedAccountList),
          status: buildAccountParameter(selectedStatus),
          userCurrency: userCurrency,
        }
        if (api_parameters.account && api_parameters.status) {

          const data = await moondanceApi.fetchPositionCurrentYear(api_parameters);
          //console.log('fetchPositionCurrentYear', data)




          let dataSet = [
            {
              title: 'Actual (year to date)',
              capitalCall: data.data.sum_real_capital_call_in_user_currency,
              distribution: data.data.sum_real_distribution_in_user_currency,
              cashFlow: data.data.sum_real_capital_call_in_user_currency + data.data.sum_real_distribution_in_user_currency,
            },
            {
              title: 'Expected  (until end of year ' + data.data.year + ')',
              capitalCall: data.data.sum_model_capital_call_in_user_currency - data.data.sum_real_capital_call_in_user_currency,
              distribution: data.data.sum_model_distribution_in_user_currency - data.data.sum_real_distribution_in_user_currency,
              cashFlow: (data.data.sum_model_capital_call_in_user_currency - data.data.sum_real_capital_call_in_user_currency) + (data.data.sum_model_distribution_in_user_currency - data.data.sum_real_distribution_in_user_currency),
            },

          ]
          setData(dataSet);
          setLoading(false)
        

        }

      } catch (error) {
        console.log(error);
      }
    }
    fetchData();
  }, [selectedAccountList, selectedStatus, userCurrency]);

  return (
    <React.Fragment>
      {(loading ? <Loading />:

        (data && data.length > 0) ?

          <MoondanceTable
            key={'currentYearData'}
            title={"Current Year"}
            rows={data}
            paginationSize={20}
            hideExportButton={true}
            hideTopRow={true}
            hideSortButton={true}
            columns={
              [
                {
                  label: 'Actual / Expected',
                  field: 'title',
                  showTotal: false,

                },
                {
                  label: 'Capital Calls',
                  field: 'capitalCall',
                  format: 'currency', formatUnit: userCurrency,

                  align: 'right', showTotal: true
                },
                {
                  label: 'Distribution',
                  field: 'distribution',
                  format: 'currency', formatUnit: userCurrency,

                  align: 'right', showTotal: true
                },
                {
                  label: 'Cash Flow',
                  field: 'cashFlow',
                  format: 'currency', formatUnit: userCurrency,

                  align: 'right', showTotal: true
                }
              ]

            }
          /> : null
      )}

    </React.Fragment >



  )
}


export default DashboardYearly
